import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  // === Public routes (AuthLayout wraps q-page) ===
  {
    path: '/login',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('pages/auth/LoginPage.vue'),
      },
    ],
  },
  {
    path: '/register',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'register',
        component: () => import('pages/auth/RegisterPage.vue'),
      },
    ],
  },
  {
    path: '/verificar/:certNumber',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'verificar',
        component: () => import('pages/VerificarPage.vue'),
        props: true,
      },
    ],
  },

  // === Protected routes (with MainLayout) ===
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      // --- Dashboard ---
      {
        path: '',
        name: 'dashboard',
        component: () => import('pages/DashboardPage.vue'),
        meta: { resource: 'dashboard' },
      },

      // --- Profile ---
      {
        path: 'profile',
        name: 'profile',
        component: () => import('pages/ProfilePage.vue'),
        meta: { resource: 'profile' },
      },

      // --- Formacion ---
      {
        path: 'courses',
        name: 'courses',
        component: () => import('pages/CoursesPage.vue'),
        meta: { resource: 'courses' },
      },
      {
        path: 'courses/:slug',
        name: 'course-detail',
        component: () => import('pages/CourseDetailPage.vue'),
        meta: { resource: 'courses' },
      },
      {
        path: 'learn',
        name: 'learn',
        redirect: '/courses',
        meta: { resource: 'learn' },
      },
      {
        path: 'learn/:courseId',
        name: 'learn-course',
        component: () => import('pages/LearnCoursePage.vue'),
        meta: { resource: 'learn' },
      },
      {
        path: 'learn/:courseId/lesson/:lessonId',
        name: 'lesson',
        component: () => import('pages/LessonPage.vue'),
        meta: { resource: 'learn' },
      },
      {
        path: 'quiz/:lessonId',
        name: 'quiz',
        component: () => import('pages/QuizPage.vue'),
        meta: { resource: 'learn' },
      },
      {
        path: 'achievements',
        name: 'achievements',
        component: () => import('pages/AchievementsPage.vue'),
        meta: { resource: 'achievements' },
      },
      {
        path: 'ascenso',
        name: 'ascenso',
        component: () => import('pages/AscensoPage.vue'),
        meta: { resource: 'ascenso' },
      },
      {
        path: 'certificacion',
        name: 'certificacion',
        component: () => import('pages/CertificacionPage.vue'),
        meta: { resource: 'certificacion' },
      },

      // --- Supervision ---
      {
        path: 'evaluations',
        name: 'evaluations',
        component: () => import('pages/evaluations/EvaluationsPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/submit/:templateId',
        name: 'evaluation-submit',
        component: () => import('pages/evaluations/SubmitPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/review/:submissionId',
        name: 'evaluation-review',
        component: () => import('pages/evaluations/ReviewPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/instruments',
        name: 'instruments',
        component: () => import('pages/evaluations/InstrumentsPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/history',
        name: 'eval-history',
        component: () => import('pages/evaluations/HistoryPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/live/:cycleId',
        name: 'live-eval',
        component: () => import('pages/evaluations/LiveEvalPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/results/:cycleId',
        name: 'eval-results',
        component: () => import('pages/evaluations/ResultsPage.vue'),
        meta: { resource: 'evaluations' },
      },
      {
        path: 'evaluations/evolution/:userId',
        name: 'evolution',
        component: () => import('pages/evaluations/EvolutionPage.vue'),
        meta: { resource: 'evolution' },
      },

      // --- Operaciones ---
      {
        path: 'incorporacion',
        name: 'incorporacion',
        component: () => import('pages/IncorporacionPage.vue'),
        meta: { resource: 'incorporacion' },
      },
      {
        path: 'guia',
        name: 'guia',
        component: () => import('pages/GuiaPage.vue'),
        meta: { resource: 'guia' },
      },
      {
        path: 'guia/:situationId',
        name: 'guia-situation',
        component: () => import('pages/GuiaSituationPage.vue'),
        meta: { resource: 'guia' },
      },
      {
        path: 'legal',
        name: 'legal',
        component: () => import('pages/LegalPage.vue'),
        meta: { resource: 'legal' },
      },
      {
        path: 'legal/:documentId',
        name: 'legal-document',
        component: () => import('pages/LegalDocumentPage.vue'),
        meta: { resource: 'legal' },
      },
      {
        path: 'sede',
        name: 'sede',
        component: () => import('pages/SedePage.vue'),
        meta: { resource: 'sede' },
      },
      {
        path: 'ot',
        name: 'ot',
        component: () => import('pages/OtDashboardPage.vue'),
        meta: { resource: 'ot' },
      },

      // --- Organizacion ---
      {
        path: 'community',
        name: 'community',
        component: () => import('pages/CommunityPage.vue'),
        meta: { resource: 'community' },
      },

      // --- Admin ---
      {
        path: 'admin',
        name: 'admin',
        component: () => import('pages/AdminPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/users',
        name: 'admin-users',
        component: () => import('pages/AdminUsersPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/courses',
        name: 'admin-courses',
        component: () => import('pages/AdminCoursesPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/certificates',
        name: 'admin-certificates',
        component: () => import('pages/AdminCertificatesPage.vue'),
        meta: { resource: 'admin' },
      },
    ],
  },

  // === Catch-all 404 ===
  {
    path: '/:catchAll(.*)*',
    name: 'not-found',
    component: () => import('pages/NotFoundPage.vue'),
  },
];

export default routes;
